module.exports = __webpack_public_path__ + "static/img/q12025_crm_used.af24b57.jpg";